export { PaginationComponent } from './pagination.component';
export { PaginationConfig } from './pagination-config';
export { PaginationEvent } from './pagination-event';
export { PaginationModule } from './pagination.module';
